// Names and TTLs for the in-house attribution cookies. Centralized so the
// middleware (which sets ffl_vid), the /r/[code] redirect (which sets ffl_attr),
// the organic /api/attribution/track route, and the signup action all agree.

export const VISITOR_COOKIE = 'ffl_vid';
export const ATTRIBUTION_COOKIE = 'ffl_attr';

// 2 years - long enough that a returning prospect is still recognized as the
// same anonymous visitor. Not used for auth, no PII inside.
export const VISITOR_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 2;

// 90 days - matches GA4's default first-touch window and Woo's standard
// attribution window. After 90 days of no interaction we let a fresh first-touch
// be captured.
export const ATTRIBUTION_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
